import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import {
  fetchAssessmentsList,
  getAssessmentDetails,
  getexamDetails,
  getsaveExamAnswer,
  getstartExam,
  ResendAssessmentCode,
  VerifyAssessmentCode,
} from "./actions";

const initialState = {
  assessmentsList: {},
  assessmentListLoading: false,
  assessmentListError: null,

  verifyCodeData: {},
  verifyCodeDataLoading: false,
  verifyCodeDataError: null,

  resendCodeData: {},
  resendCodeDataLoading: false,
  resendCodeDataError: null,

  assessmentDetailList: {},
  assessmentDetailListLoading: false,
  assessmentDetailListError: null,

  startExamList: {},
  startExamListLoading: false,
  startExamListError: null,

  examDetailList: {},
  examDetailListLoading: false,
  examDetailListError: null,

  saveExamDetailList: {},
  saveExamDetailListLoading: false,
  saveExamDetailListError: null,
};
const assessmentsListSlice = createSlice({
  name: "assesmentList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssessmentsList.pending, (state) => {
        state.assessmentListLoading = true;
        state.assessmentListError = null;
      })
      .addCase(fetchAssessmentsList.fulfilled, (state, action) => {
        state.assessmentListLoading = false;
        state.assessmentsList = action.payload;
      })
      .addCase(fetchAssessmentsList.rejected, (state, action) => {
        state.assessmentListLoading = false;
        state.assessmentListError = action.payload;
      });

    builder
      .addCase(VerifyAssessmentCode.pending, (state) => {
        state.verifyCodeDataLoading = true;
        state.verifyCodeDataError = null;
      })
      .addCase(VerifyAssessmentCode.fulfilled, (state, action) => {
        state.verifyCodeDataLoading = false;
        state.verifyCodeData = action.payload;
        if (action?.payload?.meta?.status === "ok") {
          notification.success({
            message: "Success",
            description: action?.payload?.meta?.message,
            duration: 3,
          });
        } else {
          // notification.error({
          //   message: "Error",
          //   description: action?.payload?.meta?.message,
          //   duration: 3,
          // });
        }
      })
      .addCase(VerifyAssessmentCode.rejected, (state, action) => {
        state.verifyCodeDataLoading = false;
        state.verifyCodeDataError = action.payload;
      });

    builder
      .addCase(ResendAssessmentCode.pending, (state) => {
        state.resendCodeDataLoading = true;
        state.resendCodeDataError = null;
      })
      .addCase(ResendAssessmentCode.fulfilled, (state, action) => {
        state.resendCodeDataLoading = false;
        state.resendCodeData = action.payload;
        if (action?.payload?.meta?.status === "ok") {
          notification.success({
            message: "Success",
            description: action?.payload?.meta?.message,
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error",
            description: action?.payload?.message,
            duration: 2,
          });
        }
      })
      .addCase(ResendAssessmentCode.rejected, (state, action) => {
        state.resendCodeDataLoading = false;
        state.resendCodeDataError = action.payload;
      });

    builder
      .addCase(getAssessmentDetails.pending, (state) => {
        state.assessmentDetailListLoading = true;
        state.assessmentDetailListError = null;
      })
      .addCase(getAssessmentDetails.fulfilled, (state, action) => {
        state.assessmentDetailListLoading = false;
        state.assessmentDetailList = action.payload;
      })
      .addCase(getAssessmentDetails.rejected, (state, action) => {
        state.assessmentDetailListLoading = false;
        state.assessmentDetailListError = action.payload;
      });

    builder
      .addCase(getstartExam.pending, (state) => {
        state.startExamListLoading = true;
        state.startExamListError = null;
      })
      .addCase(getstartExam.fulfilled, (state, action) => {
        state.startExamListLoading = false;
        state.startExamList = action.payload;
      })
      .addCase(getstartExam.rejected, (state, action) => {
        state.startExamListLoading = false;
        state.startExamListError = action.payload;
      });

    builder
      .addCase(getexamDetails.pending, (state) => {
        state.examDetailListLoading = true;
        state.examDetailListError = null;
      })
      .addCase(getexamDetails.fulfilled, (state, action) => {
        state.examDetailListLoading = false;
        state.examDetailList = action.payload;
      })
      .addCase(getexamDetails.rejected, (state, action) => {
        state.examDetailListLoading = false;
        state.examDetailListError = action.payload;
      });

    builder
      .addCase(getsaveExamAnswer.pending, (state) => {
        state.saveExamDetailListLoading = true;
        state.saveExamDetailListError = null;
      })
      .addCase(getsaveExamAnswer.fulfilled, (state, action) => {
        state.saveExamDetailListLoading = false;
        state.saveExamDetailList = action.payload;
      })
      .addCase(getsaveExamAnswer.rejected, (state, action) => {
        state.saveExamDetailListLoading = false;
        state.saveExamDetailListError = action.payload;
      });
  },
});
export default assessmentsListSlice.reducer;
